<template>
  <div class="passwordPage">
    <div class="head_wrapper flex-rowl">
      <i class="iconfont icon-anquan"></i>
      <div class="cont">
        <p>安全中心</p>
        <p>账号安全及密保管理</p>
      </div>
    </div>
    <div class="from_wrapper">
      <div class="from">
        <div class="input_box" v-if="isPwd">
          <span class="mark">*</span>
          <van-field
            v-model="oldpwd"
            :type="oldPwdType"
            maxlength="18"
            placeholder="输入旧密码"
          />
          <div class="visual" @click="handleVisualPwd(3)">
            <i
              class="iconfont"
              :class="
                oldPwdType == 'password' ? 'icon-icon_xianshi' : 'icon-xianshi'
              "
            ></i>
          </div>
        </div>
        <div class="input_box">
          <span class="mark">*</span>
          <van-field
            v-model="pwd"
            :type="pwdType"
            maxlength="18"
            placeholder="请输入密码（6~18位英文加数字，区分大小写）"
          />
          <div class="visual" @click="handleVisualPwd(1)">
            <i
              class="iconfont"
              :class="
                pwdType == 'password' ? 'icon-icon_xianshi' : 'icon-xianshi'
              "
            ></i>
          </div>
        </div>
        <div class="input_box">
          <span class="mark">*</span>
          <van-field
            v-model="pwd2"
            :type="pwd1Type"
            maxlength="18"
            placeholder="请再次输入密码，请确保与首次输入的密码保持一致"
          />
          <div class="visual" @click="handleVisualPwd(2)">
            <i
              class="iconfont"
              :class="
                pwd1Type == 'password' ? 'icon-icon_xianshi' : 'icon-xianshi'
              "
            ></i>
          </div>
        </div>
      </div>
      <div class="submit_btn btn" @click="handleNextOne">保存设置</div>
    </div>

    <div class="custom_btn return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回首页
    </div>
  </div>
</template>
<script>
import { isSetPwd, setPwd, updatePass } from "../../api/api";
export default {
  name: "setPwd",
  data() {
    return {
      oldPwdType: "password",
      pwdType: "password",
      pwd1Type: "password",
      oldpwd: "",
      pwd: "",
      pwd2: "",

      isPwd: false, // 是否已设置密码
    };
  },
  created() {
    this.isSetPwd();
  },
  methods: {
    isSetPwd() {
      let userInfo = this.$store.state.USERINFO;
      let params = {
        mobile: userInfo.mobile,
        openid: userInfo.openid,
      };
      isSetPwd(params).then((res) => {
        this.isPwd = res.result;
      });
    },
    // 密码显示
    handleVisualPwd(type) {
      if (type == 1) {
        this.pwdType = this.pwdType == "password" ? "text" : "password";
      } else if (type == 2) {
        this.pwd1Type = this.pwd1Type == "password" ? "text" : "password";
      } else if (type == 3) {
        this.oldPwdType = this.oldPwdType == "password" ? "text" : "password";
      }
    },

    // 返回上一页
    handleReturn() {
      this.$router.back();
    },

    // 提交
    handleNextOne() {
      let userInfo = this.$store.state.USERINFO;
      let { oldpwd, pwd, pwd2, isPwd } = this;
      if (oldpwd == "" && isPwd) {
        this.$toast("请输入旧密码");
        return;
      }
      if (pwd == "" || pwd2 == "") {
        this.$toast("请输入密码");
        return;
      }
      if (pwd2 != pwd) {
        this.$toast("密码不一致，请重新输入密码");
        return;
      }
      if (pwd.length < 6 || pwd2.length < 6) {
        this.$toast("请输入最少6位数密码");
        return;
      }

      if (isPwd) {
        let params = {
          mobile: userInfo.mobile,
          openid: userInfo.openid,
          oldpwd,
          pwd,
          pwd2,
        };
        this.updatePass(params);
      } else {
        let params = {
          mobile: userInfo.mobile,
          openid: userInfo.openid,
          pwd,
          pwd2,
        };
        this.setPwd(params);
      }
    },

    // 修改密码
    updatePass(params) {
      updatePass(params).then((res) => {
        if (res.result) {
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.go(-2);
          }, 2000);
        } else {
          this.$toast.fail(res.message || '服务器报错，请稍后～');
        }
      });
    },
    // 初次设置密码
    setPwd(params) {
      setPwd(params).then((res) => {
        if (res.result) {
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.go(-2);
          }, 2000);
        } else {
          this.$toast.fail(res.message || '服务器报错，请稍后～');
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.passwordPage {
  background: hsl(0, 0%, 98%);
  height: 100vh;
  box-sizing: border-box;
  .head_wrapper {
    padding: 156px 0 38px 70px;
    .iconfont {
      font-size: 46px;
    }
    .cont {
      margin-left: 24px;
      font-size: 30px;
      color: #333333;
      p {
        &:last-child {
          font-size: 20px;
          margin-top: 7px;
        }
      }
    }
  }
  .custom_btn {
    margin-top: 120px;
  }
  .from_wrapper {
    background: #fff;
    padding: 60px 75px 86px;
    .tit {
      font-size: 24px;
      color: #333333;
      margin-bottom: 60px;
      .iconfont {
        font-size: 36px;
        margin-right: 20px;
      }
    }
    .from {
      .input_box {
        background: #f0f0f0;
        position: relative;
        border: none;
        margin-bottom: 30px;
        padding: 0 70px 0 33px;
        font-size: 20px;
        .mark {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -25px;
          font-size: 35px;
          color: #f62560;
        }
        .visual {
          position: absolute;
          top: 50%;
          right: 30px;
          transform: translateY(-50%);
          .iconfont {
            font-size: 38px;
            color: #818181;
          }
        }
      }
    }
    .btn {
      width: 280px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      background: #f62560;
      border-radius: 25px;
      font-size: 20px;
      color: #fff;
      margin: 70px auto 0;
    }
    .content {
      font-size: 30px;
      color: #333333;
      text-align: center;
      padding: 106px 0;
      .icon {
        width: 75px;
        height: 75px;
        margin: 0 auto 48px;
      }
    }
  }
  .verify-wrap {
    width: 500px;
    font-size: 20px;
  }
  .popup_box {
    height: 100vh;
    top: 0;
    position: fixed;
    z-index: 999999999999;
    width: 100%;
    .popup_wrapper {
      width: 550px;
      box-sizing: border-box;
      background: #fff;
      top: 34%;
      margin: auto;
      position: relative;
      z-index: 9999999999;
      .popup_header {
        height: 110px;
        padding: 0 20px;
        font-size: 32px;
        box-sizing: border-box;
      }
      .popup_content {
        padding: 25px 0 70px;
        position: relative;
      }
    }
  }
}
</style>